module.exports = __webpack_public_path__ + "img/famousfaces.c7a4a9ff.png";